<div class="menu-fixed">
  <div class="container flex-no-wrap rectangle">
    <button *ngIf="isMenuReady" class="menu-item button-focusable" (click)="goHome()" (keydown.enter)="goHome()"
      [attr.tabindex]="intitialMenuTabIndex">
      <span class="title">home</span>
    </button>
    <div *ngFor="let menu of categories; index as i">
      <app-menu-button id="menuOption{{i}}" (keydown.enter)="showMenuOptions(i+1)"
        [initialIndex]="intitialMenuTabIndex+i" [menuIndex]="i+1" [category]="menu" [show]="menuHoverEvent"
        [searchBarIsFocused]="searchBarIsFocused" (isHovered)="onIsHovered($event)"
        [isFullMenuGuied]="(i+1) === 1"></app-menu-button>
      <app-menu-category [lastMenu]="categories.length==(i+1)" (keydown.esc)="hideMenuOptions(i+1)" [menuIndex]="i+1"
        [category]="menu" [show]="menuHoverEvent" [initialIndex]="intitialMenuTabIndex+i"
        (clickHideMenu)="onClickMenu($event, i+1)" (mouseenter)="showMenuOptions(i+1)"
        (mouseleave)="hideMenuOptions(i+1)" (showAllOptions)="onShowAllOptions($event,i+1)"
        [isFullMenuGuied]="(i+1) === 1"></app-menu-category>
    </div>
  </div>
</div>
